import {Injectable} from '@angular/core';
import * as $ from 'jquery';

@Injectable({
  providedIn: 'root'
})
export class SidebarService {

  private _isSIdebarActive: boolean;

  constructor() {
  }

  onSidebarCollapse() {
    $('#sidebar').toggleClass('active');
    this._isSIdebarActive = $('#sidebar').hasClass('active');
    console.log('sidebar active ' + this._isSIdebarActive);
  }

  isSidebarActive() {
    return this._isSIdebarActive;
  }

  setSidebarActive() {
    this._isSIdebarActive = true;
  }

  unsetSidebarActive() {
    this._isSIdebarActive = false;
  }
}
